import Layout from '@/layout/index.vue';
import { transactionsSubMenu } from './subMenus/transaction-sub-menu';
import { ledgersSubMenu } from './subMenus/ledger-sub-menu';
const accountManagementRouter = {
  path: '/account',
  component: Layout,
  redirect: 'noredirect',
  name: 'accountManagement.title',
  meta: {
    roles: ['Super Admin', 'Admin', 'Agent', 'Branch Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Account Manager', 'Invoice Manager', 'Sales Manager', 'Payment Manager'],
    title: 'accountManagement.title',
    icon: 'nested'
  },
  children: [...transactionsSubMenu, ...ledgersSubMenu]
};
export default accountManagementRouter;